<template>
  <v-app>
    <AppHeader ref="appHeader"/>

    <v-main class="main-body">
      <!-- body -->
      <v-container>
        <v-row>
          <v-col sm="12" md="12" cols="12">
            <v-card elevation="0" color="#121621">
              <v-card-title>{{curLanguage == 'en' ? curBanner.title: curBanner.title_zh}}</v-card-title>
              <v-card-text>{{curLanguage == 'en' ?curBanner.content: curBanner.content_zh}}</v-card-text>
              <div style="height: 80px;"></div>
              <v-row style="justify-content: center;background-color: #121621;">
                <v-col v-if="approveList.length == 0" cols="12" lg="12" md="12" xl="12" sm="12" style="padding: 0px 6px;align-items: center;flex-direction: column;display: flex;" >
                    <div style="color: #FFFFFF; font-size: 20px; font-weight: bold;">No Content</div>
                    <v-img :src="nocontentimage">
                    </v-img>
                    
                  </v-col>
                  <v-col v-show="approveList.length > 0" @click.stop="revokeApprove(m)" cols="12" lg="12" md="12" xl="12" sm="12" style="align-items: center;padding: 8px 3px;justify-content: space-between;display: flex;border-bottom: 1px solid rgba(63,81,181,0.45);" v-for="(item, m) in approveList" :key="m">
                      <div class="token-box">
                        <span class="hash-class"><span style="display:flex;">{{$t('me.accountInfo.approveTokenName')}}: <img v-if="item.tokenInfo.iconUrl" class="logo-icon" :src="item.tokenInfo.iconUrl" /></span><span style="color: #ffc107;">{{ item.tokenInfo.name}}</span></span>
                        <span class="time-class"><span style="display:block;">{{$t('me.accountInfo.approveNumber')}}: </span><span style="color: #ffc107;">{{'ERC20' == item.tokenInfo.type ? parseInt(item.value): 1}}</span></span>
                      </div>
                      <div class="token-box">
                        <span class="hash-class "><span style="display:block;">{{$t('me.accountInfo.spender')}}: {{item.spenderName}}</span><span class="hash-text">{{item.spender.substring(0,10) + '...' + item.spender.substring(item.spender.length-4)}}</span></span>
                        <span class="time-class"><span style="display:block;">{{$t('me.accountInfo.approveOperation')}}: </span><span style="color: #ffc107;">{{$t('me.accountInfo.approveCancel')}}</span></span>
                      </div>
                      
                      <v-icon class="iconfont iconright" style="font-size: 20px;color:#FFFFFF;"></v-icon>
          
                  </v-col>
              </v-row>
              
            </v-card>
          </v-col>

          
        </v-row>

        
        <v-row> 
          <v-col sm="12" md="12" cols="12">
            <v-card elevation="0" color="#F4F4F4">
              
              <v-row class="card-box">
                <v-col 
                  v-for="(item, n) in exploreJson"
                  :key=n
                  xs="6" sm="3" md="3" cols="6">
                  
                </v-col>
                
              </v-row>
              
            </v-card>
          </v-col>
        </v-row>

        
      </v-container>
    </v-main>
    <dialog-loader ref="dialogLoader"></dialog-loader>
    <confirm-dialog ref="confirmDialog" />
    <h-dialog />
    <!-- <h-notify />
    <h-loader /> -->

  </v-app>
</template>

<script>
import AppHeader from '../../components/AppHeader.vue';
import ConfirmDialog from '../../components/ConfirmDialog.vue';

export default {
  name: 'App',

  components: {
    AppHeader,
    ConfirmDialog
  },

  data: () => ({
    balance: '-',
    confirmStatus: false,
    isShow: -1,
    account: null,
    curLanguage: 'zh-cn',
    curActiveTab: 0,
    curBanner: {
      title: 'Reward ConfluxDapp',
      title_zh: '打赏 ConfluxDapp',
      content: '',
      content_zh: '',
    },
    clockIcon: require('../../assets/svg/clock.svg'),
    trendingJson: [],
    hotbidJson: [],
    exploreJson: [],
    categoryList: [],
    boxList: [],
    currentCategory: 0,
    timelock: null,
    approveList: [],
    approveCount: 0,
    nocontentimage: require('../../assets/images/me/haita.png'),
  }),
  mounted: async function() {
    //TODO:
    let that = this
    this.account = await this.$refs.appHeader.login();

    that.loadApproveList()

    // setTimeout(function() {
    //   that.loadApproveList()
    // }, 200)
   
  },
  watch: {
    account: {
      handler(newVal, oldVal) {
        
      },
      immediate: true
    },
    '$i18n.locale': {
      handler(newVal, oldVal) {

        if(newVal == 'zh-cn') {
          this.curLanguage = 'zh-cn'
        }
        if(newVal == 'en') {
          this.curLanguage = 'en'
        }
        
        
      },
      immediate: true
    }
  },
  beforeDestroy: function() {
    this.destoryClock()
  },
  methods: {
    login: async function() {
      this.account = await this.$refs.appHeader.login();
    },
    loadApproveList: function() {
      let that = this
      that.account = "cfx:aajnd1hhr8k96tk190nr32unc60x63gf9aucuvf77u"
      that.tag = "conflux"
      that.queryApproveList(that.tag, that.account).then(res => {
        console.log(res)
        that.approveList = res.data.data.list
        that.approveCount = res.data.data.total
        console.log(that.approveCount)
        that.$forceUpdate()

      }).catch(error => {
        console.log("error", error)
      })
    },
    revokeApprove: function(num) {
      let that = this

      try {
          let approveInfo = that.approveList[num]

          let title = that.$i18n.locale != 'en' ? "提示": "Tips"
          let text_en = "Whether to revoke approve"
          let text_cn = "是否要撤销授权"
          let validBidText = that.$i18n.locale != 'en' ? text_cn : text_en
          let btns = that.$i18n.locale != 'en' ? ["取消","确认"]: ["Cancel","Confirm"]

          let param = {
            'holder': that.account, 
            'spender': approveInfo.spender,
            'amount': "0", 
            'contract': approveInfo.contract, 
            "chainType": that.chainType
          }

          that.$refs.confirmDialog.confirm(title, validBidText , btns, async function() {
            
            
          })
          
        } catch(e) {
          console.log(e)
        }
    },
    reward: async function() {
      console.log("reward")
      if(this.balance < this.price) return;
      this.confirmStatus = true
      let that = this
      try {
        let result = await that.transferToken(this.coinType.address, this.globalVar.account, "cfx:aatnwhyaf3sz4vt088nnr73vt3czp34fsjsaw30v1e", this.price)
        console.log(result)
        if(0 == result.outcomeStatus) {
          console.log(result.transactionHash)
          this.price = ''
          this.coinType = {}

          try {
          
            let title = that.$i18n.locale != 'en' ? "鸣谢": "Give thanks"
            let text_en = "Thank you, boss, for your gift."
            let text_cn = "感谢老板的馈赠，预感您将要暴富了！"
            let validBidText = that.$i18n.locale != 'en' ? text_cn : text_en
            let btns = that.$i18n.locale != 'en' ? ["取消","确认"]: ["Cancel","Confirm"]

            that.$refs.confirmDialog.confirm(title, validBidText , btns, async function() {
              
            })
            
          } catch(e) {
            console.log(e)
          }
        }
        
      } catch(e) {
        this.confirmStatus = false
      }
      
      this.confirmStatus = false
    },
    selectCoin: async function() {
      let that = this
      let balance = await that.getBalance(this.globalVar.account, this.coinType.address)

      this.balance = balance
    },
    destoryClock: function() {
      window.clearInterval(this.timelock)
      this.timelock = null
    },
    dealClock: function() {
      let that = this
      
      for(var i = 0 ; i < that.hotbidJson.length; i++) {
        if(null != that.hotbidJson[i].expirationTime) {
          
          let tempTime = that.hotbidJson[i].expirationTime
          that.hotbidJson[i].expirationTime = null
          that.hotbidJson[i].expirationTime = tempTime
        }
        
      }
      
    },
    loadCategory: function() {
      //Category
      window.API.category.getCategoryList.request({
        "count": 0,
        "pageSize": 10
      }).then(res => {
        this.categoryList = res.data.data.categoryList
      })
    },
    loadHotBid: function() {
      let that = this
      that.$refs.dialogLoader.show( that.$i18n.locale == 'en' ? 'Data Loading...' : '数据加载中...', { color: 'primary' } )

      that.destoryClock()
      //hot bid
      window.API.item.browseItemList.request({
        "category": "1",
        "count": 0,
        "pageSize": 4,
        "sortBy": "highestBid",
        "status": "auction"
      }).then(res => {
        if(0 == res.data.code) {
          this.hotbidJson = this.packageCollectibleData(res.data.data.itemList)

          that.timelock = setInterval(function() {
            that.dealClock()
          }, 1000)
        }

        that.$refs.dialogLoader.hide()
      })
    },
    listExplore(category) {
      let that = this
      //Expolre
      window.API.item.browseItemList.request({
        "category": '',
        "count": 0,
        "pageSize": 4,
        "sortBy": "recentList",
        "status": "buyNow"
      }).then(res => {
        
        if(0 == res.data.code) {
          
          that.exploreJson = this.packageCollectibleData(res.data.data.itemList)
        }
      })
    },
    loadCollection: function() {
      
      let that = this

      let params = {
        count: 0,
        pageSize: 4
      }

      window.API.collection.getTrendingCollectionList.request(params).then(res => {
        if(0 == res.data.code) {
          that.trendingJson = res.data.data.trendingCollection
        }
      })
      
    },

    loadBlindBox: function() {
      let that = this

      window.API.box.searchBox.request({
        "count": 0,
        "pageSize": 4,
        "search": '',
        "sortBy": ''
      }).then(res => {
        if(0 == res.data.code) {
          that.boxList = res.data.data.boxList
        }
        
      })
    },
    viewDetail4HotBid: function(n, type) {
      let id = this.hotbidJson[n]['id']
      this.$router.push({ name: 'Detail', params: {id: id, listingStatus: 1}, query: {id: id, listingStatus: 1}})
    },
    viewDetail: function(n, type) {
      let id = this.exploreJson[n]['id']
      this.$router.push({ name: 'Detail', params: {id: id, listingStatus: 1}, query: {id: id, listingStatus: 1}})
    },
    showMore: function() {
      // this.sheet = true;
      this.drawer = true;
    },
    showExplore: function(n) {

      if(typeof n == "number") {
        let collectionId = this.trendingJson[n].id
        this.$router.push({ name: 'Explore', params: {collectionId: collectionId}, query: {collectionId: collectionId}})
      } else {
        this.$router.push({ name: 'Explore', params: {}})
      }
      
    },
    showBlindBoxDetail: function(n, type){
      //添加样式
      this.isShow = n 

      let id = this.boxList[n]['id']
      this.$router.push({ name: 'BlindBoxDetail', params: {id: id, onlineOrNot: 1}, query:{id: id, onlineOrNot: 1}});
    }
  }

};
</script>

<style scoped>

  .tuoyuan {
    position: absolute;
    width: 8px;
    height: 8px;
    background: #7CD77B;
  }

  .main-body {
    padding-top: 0px !important;
    font-size: 12px;
    background-color: #121621;
    padding-bottom: 20px !important;
    /* background: linear-gradient(90deg, #000000 0%, #3f51b5 50%, #000000 100%); */
}


  
		
		.tokenItem {
			margin: 8px 5px;
			height: 44px;
			background-color: #696A6F;
			border-radius: 4px;
      display: flex;
      justify-content: space-between;
      align-items: center;
		}
		
		.token-logo1 {
			float: left;
			margin: 2px 0px;
			margin-right: 10px;
		}
		.balance {
			color: white;
			font-size: 16px;
			line-height: 44px;
			text-align: left;
			min-width: 150px;
      padding-left:10px;
		}

    .hash-text {
			color: #03a9f4;
			font-size: 15px;
			line-height: 30px;
			text-align: left;
			min-width: 120px;
		}
		
		.dapp-box {
			margin: 0 3px;
			float: left;
		}
		
		.app-logo {
			margin: 12px auto;
		}
		
		.text-gray {
			color: #CFCFCF;
		}

    .iconfont-container{
		  margin:5px 10px;
		  text-align:center;
		  color:#ffc107;
		  display: inline-block;
		}

		.iconfont-text{
		  display:block;
		  font-size:0.75rem;
		}
		
		.iconfont {
			color: #ffc107;
			font-size: 1.875rem;
		}

    .coinName {
			width: 30px;
			line-height: 44px;
			display: block;
			color: #FFFFFF;
			font-size: 13px;
		}

    .logo-box {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .iconfont-small {
      font-size: 24px;
    }
    
    .hash-class {
			width: auto;
			line-height: 30px;
			display: block;
			color: #FFFFFF;
			font-size: 13px;
		}

    .time-class {
      display: block;
      line-height: 30px;
      color: #FFFFFF;
      font-size: 13px;
    }

    .token-box {
      margin: 0px 10px;
      width: 50%;
    }

    .pending-class {
      margin-left: 10px;
      color: red;
    }

    .logo-icon {
      width: 25px;
      height: 25px;
      margin-left: 8px;
    }
  
</style>
